function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import { PASSWORD_VISIBLE_ICON, PASSWORD_HIDDEN_ICON } from './constants';
import PasswordIconButton from './PasswordIconButton';
import { TYPE_TEXT, TYPE_PASSWORD } from '../textInput/constants';
import TextInput from '../textInput/TextInput';
import InputField from '../inputField/InputField';
import { getAdditionalProps } from '../utils/propTypes';
var DEFAULT_INPUT_FIELD_PROPS = {
  style: 'basic',
  label: 'password'
};

var Password =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Password, _React$PureComponent);

  function Password(props) {
    var _this;

    _classCallCheck(this, Password);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Password).call(this, props));
    var defaultValue = props.defaultValue;
    var value = props.value;
    value = value || defaultValue;
    _this.state = {
      isTextVisible: false,
      isIconVisible: value.length !== 0
    };
    return _this;
  }

  _createClass(Password, [{
    key: "_handleIconClick",
    value: function _handleIconClick() {
      var isTextVisible = this.state.isTextVisible;
      this.setState({
        isTextVisible: !isTextVisible
      });
    }
  }, {
    key: "_handleOnChange",
    value: function _handleOnChange(value) {
      var onChange = this.props.onChange;
      this.setState({
        isIconVisible: value.length !== 0
      });

      if (onChange) {
        onChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          disabled = _this$props.disabled,
          role = _this$props.role,
          hasError = _this$props.hasError,
          required = _this$props.required,
          defaultValue = _this$props.defaultValue,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          isV2 = _this$props.isV2,
          value = _this$props.value;
      var extraAttrs = getAdditionalProps(this);
      var _this$state = this.state,
          isTextVisible = _this$state.isTextVisible,
          isIconVisible = _this$state.isIconVisible;
      var textInputType = isTextVisible ? TYPE_TEXT : TYPE_PASSWORD;
      var iconType = isTextVisible ? PASSWORD_HIDDEN_ICON : PASSWORD_VISIBLE_ICON;
      var InputComponent = TextInput;
      var PasswordIcon = React.createElement(PasswordIconButton, {
        showIcon: isIconVisible,
        iconType: iconType,
        togglePasswordVisibility: this._handleIconClick.bind(this)
      });
      var classes = 'eds-password';
      var sharedProps = {
        id: id,
        name: name,
        onFocus: onFocus,
        onBlur: onBlur,
        defaultValue: defaultValue,
        value: value,
        disabled: disabled,
        required: required,
        hasError: hasError,
        role: role,
        type: textInputType,
        onChange: this._handleOnChange.bind(this)
      };

      var inputProps = _objectSpread({}, sharedProps, {
        children: PasswordIcon,
        iconAlignRight: true
      });

      if (isV2) {
        InputComponent = InputField;
        classes = 'eds-password--v2'; //Apply prop setup specific for InputField
        //and pick/merge fromthe incoming props the
        //configurations specific to the InputField

        inputProps = _objectSpread({
          suffix: PasswordIcon,
          hasMinAsideSpacing: true
        }, DEFAULT_INPUT_FIELD_PROPS, pick.apply(void 0, [this.props].concat(_toConsumableArray(Object.keys(InputField.propTypes)))), sharedProps);
      }

      return React.createElement("div", {
        className: classes
      }, React.createElement(InputComponent, _extends({}, extraAttrs, inputProps)));
    }
  }]);

  return Password;
}(React.PureComponent);

_defineProperty(Password, "propTypes", {
  /**
  * ID of TextInput
  */
  id: PropTypes.string.isRequired,

  /**
  * Name of TextInput
  */
  name: PropTypes.string,

  /**
  * Role of text input
  */
  role: PropTypes.string,

  /**
  * Is required
  */
  required: PropTypes.bool,

  /**
  * Set error state
  */
  hasError: PropTypes.bool,

  /**
  * If InputField should be set to a disabled state
  **/
  disabled: PropTypes.bool,

  /**
   * Default value of TextInput
   **/
  defaultValue: PropTypes.string,

  /**
   * Value of TextInput
   **/
  value: PropTypes.string,

  /**
   * {function} onChange
   */
  onChange: PropTypes.func,

  /**
   * {function} onBlur
   */
  onBlur: PropTypes.func,

  /**
   * {function} onFocus
   */
  onFocus: PropTypes.func,

  /*
   * Boolean to determine if InputField should be
   * the internal input component used as opposed
   * to TextInput
   */
  isV2: PropTypes.bool
});

_defineProperty(Password, "defaultProps", {
  disabled: false,
  defaultValue: '',
  role: 'password'
});

export { Password as default };